import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  NgbToastModule, NgbProgressbarModule
} from '@ng-bootstrap/ng-bootstrap';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';

import { FlatpickrModule } from 'angularx-flatpickr';
import { CountUpModule } from 'ngx-countup';
import { NgApexchartsModule } from 'ng-apexcharts';
import { LeafletModule } from '@bluehalo/ngx-leaflet';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { SimplebarAngularModule } from 'simplebar-angular';

// Swiper Slider
import { SlickCarouselModule } from 'ngx-slick-carousel';

// import { LightboxModule } from 'ngx-lightbox';

// Load Icons
import { defineElement } from "@lordicon/element";
import lottie from 'lottie-web';

// Pages Routing
import { PagesRoutingModule } from "./pages-routing.module";
import { SharedModule } from "../shared/shared.module";
import { WidgetModule } from '../shared/widget/widget.module';
import { DashboardComponent } from './dashboards/dashboard/dashboard.component';
import { ToastsContainer } from './dashboards/dashboard/toasts-container.component';
import { DashboardsModule } from "./dashboards/dashboards.module";
import { AppsModule } from "./apps/apps.module";
import { EcommerceModule } from "./ecommerce/ecommerce.module";
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { MaterialAcceptanceListComponent } from './material-acceptances/list/material-acceptance-list.component';
import { PurchaseOrdersComponent } from './purchase-orders/purchase-orders.component';

import { ItemComponent } from './item/item.component';
import { SupplierComponent } from './supplier/supplier.component';
import { PriceHistoriesComponent } from './price-histories/price-histories.component';
import { QualityChecksComponent } from './quality-checks/quality-checks.component';
import { InventoryComponent } from './inventory/inventory.component';
import { MaterialConsumptionComponent } from './material-consumption/material-consumption.component';
import { InventoryTransactionsComponent } from './inventory-transactions/inventory-transactions.component';
import { DemandsComponent } from './demands/demands.component';

@NgModule({
  declarations: [
    DashboardComponent,
    ToastsContainer,
    MaterialAcceptanceListComponent,
    PurchaseOrdersComponent,
    ItemComponent,
    SupplierComponent,
    PriceHistoriesComponent,
    QualityChecksComponent,
    InventoryComponent,
    MaterialConsumptionComponent,
    InventoryTransactionsComponent,
    DemandsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ReactiveFormsModule,
    NgbToastModule,
    NgbPaginationModule,
    NgbProgressbarModule,
    NgbModule,
    NgSelectModule,
    FlatpickrModule.forRoot(),
    CountUpModule,
    NgApexchartsModule,
    LeafletModule,
    NgbDropdownModule,
    SimplebarAngularModule,
    PagesRoutingModule,
    SharedModule,
    WidgetModule,
    SlickCarouselModule,
    // LightboxModule,
    DashboardsModule,
    AppsModule,
    EcommerceModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PagesModule {
  constructor() {
    defineElement(lottie.loadAnimation);
  }
}
